<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' ,fullScreenBackdrop:true}">
</ngx-loading>
<div class="wrapper">
    <app-sidebar></app-sidebar>
    <app-header></app-header>

    <div class="page-wrapper">
        <div class="page-content">
            <!--breadcrumb-->
            <div class="page-breadcrumb d-none d-sm-flex align-items-center mb-4">
                <div class="breadcrumb-title pe-3" *ngIf="CurrentUrl =='/update-prefer'">Prefer</div>
                <div class="breadcrumb-title pe-3" *ngIf="CurrentUrl =='/update-generation'">Generation</div>
                <div class="breadcrumb-title pe-3" *ngIf="CurrentUrl =='/update-emoji'">Emoji</div>

                <div class="ps-3">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb mb-0 p-0">
                            <li class="breadcrumb-item"><a href="javascript:void(0);" routerLink="/dashboard"><i class="bx bx-home-alt"></i></a>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page" *ngIf="CurrentUrl =='/update-prefer'" (click)="service.back()">Prefer</li>
                            <li class="breadcrumb-item active" aria-current="page" *ngIf="CurrentUrl =='/update-generation'" (click)="service.back()">Generation</li>
                            <li class="breadcrumb-item active" aria-current="page" *ngIf="CurrentUrl =='/update-emoji'" (click)="service.back()">Emoji</li>
                        </ol>
                    </nav>
                </div>
            </div>

            <div class="row">
                <div class="col-xl-7">
                    <div class="card border-top border-0 border-4 border-brand">
                        <div class="card-body p-5">
                            <div class="card-title d-flex align-items-center">
                                <div><i class="bx bxs-user me-1 font-22 brand-color"></i>
                                </div>
                                <h5 class="mb-0 brand-color" *ngIf="CurrentUrl =='/update-prefer'" (click)="service.back()">Prefer</h5>
                                <h5 class="mb-0 brand-color" *ngIf="CurrentUrl =='/update-generation'" (click)="service.back()">Generation</h5>
                                <h5 class="mb-0 brand-color" *ngIf="CurrentUrl =='/update-emoji'" (click)="service.back()">Emoji</h5>
                            </div>
                            <hr>
                            <form class="row">
                                <div class="col-12">
                                    <div class="form-group pb-4">
                                        <label class="form-label m-0" for="Username" *ngIf="CurrentUrl =='/update-generation'" > Name </label>
                                        <label class="form-label m-0" for="Username"  *ngIf="CurrentUrl =='/update-emoji' || CurrentUrl =='/update-prefer'"> Question </label>
                                        <input type="text" class="form-control " id="Username" placeholder="Name" aria-describedby="errorEmail"  [(ngModel)]="CurrentDetail.name"  [ngModelOptions]="{standalone: true}" readonly disabled>
                                    </div>
                                </div>                         
                                <div class="col-12">
                                    <div class="form-group pb-4">
                                        <label class="form-label m-0" for="Username"> Status </label>
                                        <input type="text" class="form-control " [(ngModel)]="CurrentDetail.status" [ngModelOptions]="{standalone: true}" readonly disabled>
                                    </div>
                                </div>                               
                                <div class="col-md-12" *ngIf="imgURL !=''  &&  CurrentUrl =='/update-generation'">
                                    <div class="file-upload-output">
                                        <img [src]="imgURL" alt="Admin">
                                        <button type="button" class="file-upload-edit-btn text-center" (click)="changeImage()">
                                            <i class="bx bx-pencil"></i>
                                        </button>
                                        <input type="file" id="file1" class="form-control" name="image" accept="image/*" (change)="getUploadFileDetail($event,1)" style="cursor: pointer;display: none;" />
                                    </div>
                                </div>

                                <div class="col-12" *ngIf="CurrentUrl =='/update-emoji' || CurrentUrl =='/update-prefer'">
                                    <div class="row d-flex" *ngFor="let item of CurrentDetail.answerData; let i=index">
                                        <div class="col-md-6">
                                            <div class="form-group pb-4">
                                                <label class="form-label m-0" for="Username"> Answer{{i+1}} </label>
                                                <input type="text" class="form-control " id="Username" placeholder="Name" aria-describedby="errorEmail"  [(ngModel)]="item.name"  [ngModelOptions]="{standalone: true}" readonly disabled>
                                            </div>
                                        </div> 
                                        <div class="col-md-6" >
                                            <div class="file-upload-output">
                                                <img [src]="item.icon" alt="Admin" style="height:60px;width:60px">
                                                <button type="button" class="file-upload-edit-btn text-center" (click)="changeImage();answerId=item._id">
                                                    <i class="bx bx-pencil"></i>
                                                </button>
                                                <input type="file" id="file1" class="form-control" name="image" accept="image/*" (change)="getUploadFileDetail($event,2)" style="cursor: pointer;display: none;" />
                                            </div>
                                        </div>
                                    </div>
                                   
                                </div>


                                <div class="btn-box col-12 pt-4">
                                    <button type="submit" class="btn custom-btn dark-btn px-4 me-3" (click)="service.back()">Back</button>
                                    <button type="submit" class="btn custom-btn gradient1-btn px-4" (click)="Onsubmit()" *ngIf="CurrentUrl =='/update-generation'">Submit</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <!--end row-->

        </div>
    </div>

    <app-footer></app-footer>
</div>
